export function toBoolean(val) {
  if (val === '') return val
  return val === 'true' || val == '1'
}



// WEBPACK FOOTER //
// ./src/packages/util.js